import { FC } from "react";
import type { SocialProviderAccount } from "../hooks/useSocialProviderAccounts";
import { providerTypeToIconLabel } from "./AddSocialProviderAccountButton";
import Avatar from "./Avatar";
import Typography from "./Typography";

// The confirm dialogs' account rows — the schedule confirm and post-now
// list who a write reaches the same way: provider, then who.

export const PublishConfirmAccountBody: FC<{ account: SocialProviderAccount }> = ({
  account,
}) => (
  <div className="flex gap-2 items-center min-w-0">
    <Avatar src={account.profilePicture} className="w-5 h-5 shrink-0" />
    <div className="flex flex-col min-w-0 truncate">
      <Typography variant="subtitle3" className="truncate">
        {account.name}
      </Typography>
      <Typography variant="overline" className="text-slate-500 -mt-0.5 truncate">
        {account.username}
      </Typography>
    </div>
  </div>
);

export const PublishConfirmAccountRows: FC<{
  rows: Array<{ key: string; account: SocialProviderAccount }>;
}> = ({ rows }) => (
  <div className="flex flex-col w-full mt-1 py-5 divide-y divide-slate-150">
    {rows.map(({ key, account }) => (
      <div key={key} className="flex w-full py-1.5 first:pt-0 last:pb-0">
        <div className="flex-1 flex gap-3 items-center min-w-0">
          <div className="flex gap-1 items-center truncate flex-1 min-w-0">
            <div className="w-3.5 h-3.5 shrink-0">
              {providerTypeToIconLabel[account.provider].icon}
            </div>
            <Typography variant="subtitle3" className="truncate">
              {providerTypeToIconLabel[account.provider].label}
            </Typography>
          </div>
          <div className="flex-1 min-w-0">
            <PublishConfirmAccountBody account={account} />
          </div>
        </div>
      </div>
    ))}
  </div>
);
